import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { ProjectsService } from '../../../../work/services/projects.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-release',
  templateUrl: './release.component.html'
})
export class ReleaseComponent implements OnInit {


  date: string;
  authUser: any = {};
  projectList: Array<any> = [];
  releaseLIst: Array<any> = [];
  workConstants: any = WorkConstants;
  // lastMonthFirstDate: Date;
  // lastMonthLastDate: Date;
  currentMonthFirstDate: Date;
  currentMonthLastDate: Date;
  currentyearFirstDate: Date;
  // nextMonthFirstDate: Date;
  // nextMonthLastDate: Date;
  currentyearLastDate: Date;
  currentyearfirstDate: Date;
  currentWeekLastDate: Date;
  currentWeekFirstDate: Date;
  currentDate: Date = new Date();

  private constants = Constants;

  constructor(
    private datePipe: DatePipe,
    private cookieManagerService: CookieManagerService,
    private projectsService: ProjectsService,
  ) { }

  ngOnInit() {

    let $this = this;
    let date = new Date();
    // get login user details
    this.getAuthUser();
    // check the permission to view the widget
    this.checkAdminUserPermission();
    var first = date.getDate() - date.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6
    // define dates
    // this.lastMonthFirstDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    // this.lastMonthLastDate = new Date(date.getFullYear(), date.getMonth(), 0)
    this.currentMonthFirstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.currentMonthLastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.currentyearFirstDate = new Date(date.getFullYear(), 0, 1);
    this.currentyearLastDate = new Date(date.getFullYear() + 1, 0, 0);
    this.currentWeekFirstDate = new Date(date.setDate(first));
    this.currentWeekLastDate = new Date(date.setDate(last));
    // this.nextMonthFirstDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    // this.nextMonthLastDate = new Date(date.getFullYear(), date.getMonth() +2, 0);

    // my chart details
    $('#releaseDate').val(this.currentDate.getFullYear() + '-' + this.currentDate.getMonth());
    $('#releaseDatediv').datepicker({
      autoclose: true,
      viewMode: "months",
      minViewMode: "months",
      changeMonth: true,
      changeYear: true,
      format: 'yyyy-mm'
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      var date = new Date(selectDate), y = date.getFullYear(), m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);

      $this.date = $this.datePipe.transform(selectDate, $this.constants.dateFormat);
      // get time sheet on chagne
      $this.getReleseDetails($this.datePipe.transform(firstDay, $this.constants.dateFormat), $this.datePipe.transform(lastDay, $this.constants.dateFormat));
    });
  }

  showProjectReleaseInDateRange(event, fromtDate, toDate) {
    var startDate = this.datePipe.transform(fromtDate, this.constants.dateFormat);
    var endDate = this.datePipe.transform(toDate, this.constants.dateFormat);
    // get the id from the event
    var idAttr = event.target.id;
    //remove and add new class
    $('.project-release-button').removeClass('active');
    $('#' + idAttr).addClass('active');
    // hide the custom calander
    $('#release-date').hide();
    this.getReleseDetails(startDate, endDate);
  }

  getReleseDetails(startDate, endDate) {
    this.projectsService.getProjectReviewAndReleseDetailsAccordingToDateRange({ startDate, endDate }).subscribe(
      res => {
        this.projectList = Object.keys(res.data.project).map((key) => { return res.data.project[key] });
        this.releaseLIst = Object.keys(res.data.release).map((key) => { return res.data.release[key] });
      }
    );
  }

  showDatePickerForRelease() {
    // show the custom calander
    $('#release-date').show();
    // add and remove the "active" class
    $('#project-release-custom').addClass('active');
    $('.project-release-button').removeClass('active');
  }

  /**
 * kaushalya
 * 2017-07-11
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  /**
   * kaushalya
   * 2017-07-11
   * check adminUser permission for div
   */

  checkAdminUserPermission() {
    if (this.authUser.user_role_id != WorkConstants.basicConstans.adminRoleId && this.authUser.user_role_id != WorkConstants.basicConstans.supervisorRoleId) {
      $('#releases').hide();
    } else {

      this.getReleseDetails(this.datePipe.transform(this.currentDate, this.constants.dateFormat), this.datePipe.transform(this.currentDate, this.constants.dateFormat));
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/release/release.component.ts